export interface ISelectItem<T> {
    value: T;
    label: string;
    prefix?: string;
}

export const getSelectItem = <T extends any>(items: ISelectItem<T>[], value: T) => items.find(selectItem => selectItem.value === value);

export const getSelectItemLabel = <T extends any>(items: ISelectItem<T>[], value: T) => {
    return getSelectItem(items, value)?.label;
};
